import QUERY, {
	type FieldsPageContentQuery,
} from '@jira/project-settings__project-fields/src/__generated__/FieldsPageContentQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';

const RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';

export const fieldSettingsRelayResource: RouteResource<
	PreloadedQuery<FieldsPageContentQuery, Record<string, unknown>>
> = createRelayResource<FieldsPageContentQuery>({
	type: RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
	getQuery: ({ match, query }, { tenantContext }) => {
		const { projectKey } = getProjectKeyId(match, query);

		// Parse deep link parameters
		const fieldId = query.fieldId;
		const isValidSidebarId = ['EDIT'].includes(query.sidebarId?.toUpperCase());
		const shouldPreloadField = Boolean(isValidSidebarId && !!fieldId);

		return {
			parameters: QUERY,
			variables: {
				projectKey: projectKey ?? '',
				cloudId: tenantContext.cloudId ?? '',
				preloadedFieldId: fieldId ?? 'UNUSED_STRING',
				shouldPreloadField: shouldPreloadField ?? false,
				shouldEnforceLimits:
					fg('enforce_limits_for_field_configuration_scheme_page') ||
					fg('limits_enforcement_via_backend'),
				shouldUseGuidedAutonomy: expVal('frontier-guided-autonomy-eap', 'isEnabled', false),
			},
			options: { fetchPolicy: 'network-only' },
		};
	},
});
